import React from 'react'
import {
    OverContainerSection,
    OverContainer,
    SectionTypography,
    SectionForm,
    TitleSection,
    InformationSection,
} from '../styles'
import { FormData } from './formData'
import { useTranslations } from 'src/provider/LocaleProvider'

export type SubscribeProps = {
    setCongratulations: (value: boolean) => void
    setError: (value: boolean) => void
    setEmailError: (value: boolean) => void
    width?: string
}
export const ContactForm = ({
    setCongratulations,
    setError,
    setEmailError,
}: SubscribeProps) => {
    const t = useTranslations()
    return (
        <OverContainerSection>
            <OverContainer
                marginTop={['xlarge', 'xlarge', 'xxmedium', 'xxlarge']}
            >
                <SectionTypography
                    marginBottom={['xxmedium', 'xxmedium', 0, 0]}
                >
                    <TitleSection>{t('bookACall.titleFom')}</TitleSection>
                    <InformationSection>
                        {t('bookACall.subTitleForm')}
                    </InformationSection>
                </SectionTypography>
                <SectionForm>
                    <FormData
                        setCongratulations={setCongratulations}
                        setError={setError}
                        setEmailError={setEmailError}
                    />
                </SectionForm>
            </OverContainer>
        </OverContainerSection>
    )
}
